<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'CounterLabel',

    functional: true,

    props: {
        counter: {type: Object, required: true},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const iconClass = 'fa fa-fw fa-sort-numeric-up' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.counter,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            none: parent.$t('counters.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
